export default [
  {
    name: 'workbench',
    path: 'workbench',
    component: () => import(/* webpackChunkName: 'workbench' */ '../views/workbench/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: 'groupMessage',
    name: 'groupMessage',
    component: () => import(/* webpackChunkName: 'groupMessage' */ '../views/groupMessage/index.vue'),
  },
];
